import { Checkbox, Image } from "antd"
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Question } from "@types";

interface Props {
    question?: Question;
  }

export const MultipleImageOption = ({question}: Props) => {
    const [checked, setChecked] = useState<string[]>(question?.playerAnswers?.map((item) => item.id) || []);

    useEffect(() => {
        if (question) {
            setChecked(question.playerAnswers?.map((item) => item.id) || []);
        }
    },[question])

    return (
      <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
       <Checkbox.Group value={checked} style={{ width: "100%", textAlign: "center" }} >
        {question?.answers?.map((image, index) => (
          <Checkbox value={image.id} key={index} style={{ flexDirection: "column-reverse" }}>
            <div
              style={{ width: "200px" }}
              className={ image.isCorrect ? "custom-radio-btn-valid" : checked.includes(image.id) ? "custom-radio-btn-invalid" : "custom-radio-btn"}
            >
              <Image preview={false} src={`data:image/${image.answerImageViewModel?.extension};base64,${image.answerImageViewModel?.base64Value}`} />
            </div>
          </Checkbox>
        ))}
      </Checkbox.Group>
      </motion.div>
       
    )
}